module.exports = __webpack_public_path__ + "static/media/notapp1.ffacb2c0.PNG";